import { useState } from "react";
import AppliedList from "./Applied_list";
import Pending_List from "./Pending_List";
import { useEffect } from "react";
import nodeinstance from "../../../../nodeInstance";

export default function ApplyInsurance() {
  const [indexChange, setIndexChange] = useState(0);
  const [trigger, setTrigger] = useState(false);
  const token = localStorage.getItem("nodeToken");
  const handleSubIndexChange = (value) => {
    setIndexChange(value);
    // if(value === 1){

    // }
  };
  const [dependentDetails, setDependentDetails] = useState();
  const getData = async () => {
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/AppliedList`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setDependentDetails(response.data);
      }
    } catch (error) {
      console.log("error......", error);
    }
  };
  useEffect(() => {
    getData();
  }, [trigger]);
  return (
    <>
      {/* <h2>Data to be seen here...</h2> */}
      <div className="mt-4 w-[95%] mx-auto">
        <div className="flex ">
          <button
            className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${indexChange == 0 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
            onClick={() => {
              handleSubIndexChange(0);
            }}
          >
            PENDING LIST
          </button>

          <button
            className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${indexChange == 1 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
            onClick={() => {
              handleSubIndexChange(1);
              setTrigger(!trigger);
            }}
          >
            APPLIED LIST
          </button>
        </div>
        {indexChange === 0 ? (
          <Pending_List
            titles={[
              "S.NO",
              "DEPENDENT NAME",
              "DATE OF BIRTH",
              "DEPENDENT IQAMA NUMBER",
              "RELATION",
              "CLASS",
              "GENDER",
              "HEAD OF FAMILY",
              "INSURANCE APPLY DATE",
              "DELAYED DAYS",
              "STATUS",
            ]}
          />
        ) : indexChange === 1 ? (
          <AppliedList
            titles={[
              "S.NO",
              "DEPENDENT NAME",
              "DATE OF BIRTH",
              "DEPENDENT IQAMA NUMBER",
              "RELATION",
              "CLASS",
              "GENDER",
              "HEAD OF FAMILY",
              "INSURANCE APPLY DATE",
              "DELAYED DAYS",
              "STATUS",
            ]}
            trigger={trigger}
            setTrigger={setTrigger}
            dependentDetails={dependentDetails}
          />
        ) : (
          <Pending_List />
        )}
      </div>
    </>
  );
}
